// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__xZs-W","delete":"styles_delete__3ymkh","update":"styles_update__2xR59","add":"styles_add__21Dqt"};